import { apiRequest } from './client';
import type { CreateTicketCaptureInput, CreateTicketCaptureResult, TicketCaptureView } from '../types/ticketCapture';

// Ticket Mixto: captura unificada (POST atómico e idempotente) + consulta documental del ticket.
export const createTicketCapture = (input: CreateTicketCaptureInput) =>
  apiRequest<CreateTicketCaptureResult>('/api/ticket-captures', { method: 'POST', body: JSON.stringify(input) });

export const getTicketCapture = (ticketId: string) =>
  apiRequest<TicketCaptureView>(`/api/ticket-captures/${ticketId}`);

// ---- Borradores: un ticket guardado a medias, que todavía no movió nada ----
// Recurso aparte del de captura: éste sólo guarda el formulario; el otro crea documentos y dinero.

export interface TicketDraftSummary {
  id: string;
  label: string | null;
  lineCount: number;
  storeId: string | null;
  createdByUserId: string | null;
  updatedAt: string;
}

export interface TicketDraft extends TicketDraftSummary {
  payload: unknown;
}

export const listTicketDrafts = () =>
  apiRequest<{ drafts: TicketDraftSummary[] }>('/api/ticket-drafts');

export const getTicketDraft = (draftId: string) =>
  apiRequest<{ draft: TicketDraft }>(`/api/ticket-drafts/${draftId}`);

export const saveTicketDraft = (input: { id?: string; storeId?: string | null; label?: string | null; lineCount?: number; payload: unknown }) =>
  apiRequest<{ draft: TicketDraft }>('/api/ticket-drafts', { method: 'POST', body: JSON.stringify(input) });

export const deleteTicketDraft = (draftId: string) =>
  apiRequest<{ removed: boolean }>(`/api/ticket-drafts/${draftId}`, { method: 'DELETE' });
